import { TCheckboxField, TImageField, TSocialMediaFields, TStringField } from '../../../types/sitecore.types';
import { TFooterLinkFields, TFooterSection, TFooterSectionFields } from '../../../types/footerLink.types';
import { TFooterFields, TFooterParams, TFooterProps } from '../types/footer.types';

export class FooterModel {
  private readonly fields?: TFooterFields;
  private readonly params?: TFooterParams;

  constructor(props: TFooterProps) {
    this.fields = props?.fields;
    this.params = props?.params;
  }

  private filterSectionByType(list: TFooterSection[], type: string): TFooterSection[] | undefined {
    return list?.filter((item) => item?.fields?.sectionType?.fields?.Key?.value === type);
  }

  // eslint-disable-next-line
  get footerSections(): TFooterSection[] | undefined {
    if (this.fields?.footerSections) {
      return this.filterSectionByType(this.fields?.footerSections, 'groupSectionType');
    }
    return undefined;
  }

  // eslint-disable-next-line
  get navigationSection(): TFooterLinkFields | undefined {
    if (this.fields?.footerSections) {
      return this.filterSectionByType(this.fields?.footerSections, 'navigationSectionType')?.[0]?.fields?.footerLinks?.[0]?.fields;
    }
    return undefined;
  }

  // eslint-disable-next-line
  get actionSection(): TFooterSectionFields | undefined {
    if (this.fields?.footerSections) {
      return this.filterSectionByType(this.fields?.footerSections, 'actionSectionType')?.[0]?.fields;
    }
    return undefined;
  }

  get copyrightText(): TStringField | undefined {
    return this.fields?.copyrightText;
  }

  get logoImage(): TImageField | undefined {
    return this.fields?.logoImage;
  }

  get mobileLogoImage(): TImageField | undefined {
    return this.fields?.mobileLogoImage;
  }

  get backToTopText(): TStringField | undefined {
    return this.fields?.backToTopText;
  }

  get hideSocialMedia(): TCheckboxField | undefined {
    return this.params?.hideSocialMedia;
  }

  get socialLinks(): TSocialMediaFields | undefined {
    return this.fields?.socialLinks;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
